import { render, staticRenderFns } from "./ModalBatchPluginSet.vue?vue&type=template&id=a5a708cc&scoped=true&"
import script from "./ModalBatchPluginSet.vue?vue&type=script&lang=js&"
export * from "./ModalBatchPluginSet.vue?vue&type=script&lang=js&"
import style0 from "./ModalBatchPluginSet.vue?vue&type=style&index=0&id=a5a708cc&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../code/tibava/frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a5a708cc",
  null
  
)

export default component.exports